import { ConfigurationService } from '@/common/services/configuration/configuration.service';
import { UrlService } from '@/common/services/url/url.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { filter } from 'rxjs';

@Component({
    selector: 'fe-maintenance',
    templateUrl: './maintenance.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class MaintenanceComponent implements OnInit {
    constructor(
        private readonly configuration: ConfigurationService,
        private readonly router: Router,
        private readonly url: UrlService,
        private readonly cookieService: CookieService,
    ) {}

    public ngOnInit(): void {
        this.configuration.featuresFlags
            .pipe(
                filter(
                    (item) =>
                        (item !== null && item.maintenance === false) ||
                        this.cookieService.get('debug') === '1',
                ),
            )
            .subscribe(() => this.router.navigateByUrl(this.url.format('')));
    }
}
